import React from 'react';

const ImageLibraryIcon = ({ width = 24, height = 24, color = '#000' }) => (
  <svg
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.299 8.88921C19.779 8.11921 20.049 7.21921 19.989 6.22921C19.859 4.07921 18.149 2.25921 16.019 2.02921C13.299 1.72921 10.999 3.83921 10.999 6.49921C10.999 8.98921 13.009 10.9992 15.489 10.9992C16.369 10.9992 17.189 10.7392 17.879 10.2992L20.289 12.7092C20.679 13.0992 21.319 13.0992 21.709 12.7092C22.099 12.3192 22.099 11.6792 21.709 11.2892L19.299 8.88921ZM17.999 18.9992V14.9992C17.999 14.4492 18.449 13.9992 18.999 13.9992C19.549 13.9992 19.999 14.4492 19.999 14.9992V19.9992C19.999 21.0992 19.099 21.9992 17.999 21.9992H3.99902C2.89902 21.9992 1.99902 21.0992 1.99902 19.9992V5.99921C1.99902 4.89921 2.89902 3.99921 3.99902 3.99921H8.01902C8.56902 3.99921 9.01902 4.44921 9.01902 4.99921C9.01902 5.54921 8.56902 5.99921 8.01902 5.99921H4.99902C4.44902 5.99921 3.99902 6.44921 3.99902 6.99921V18.9992C3.99902 19.5492 4.44902 19.9992 4.99902 19.9992H16.999C17.549 19.9992 17.999 19.5492 17.999 18.9992ZM6.51902 17.9992H15.499C15.909 17.9992 16.149 17.5292 15.899 17.2092L13.349 13.8192C13.159 13.5492 12.759 13.5492 12.559 13.8092L10.209 16.8292L8.64902 14.9492C8.44902 14.6992 8.06902 14.7092 7.86902 14.9592L6.12902 17.1892C5.86902 17.5192 6.09902 17.9992 6.51902 17.9992ZM12.999 6.49921C12.999 7.87921 14.119 8.99921 15.499 8.99921C16.879 8.99921 17.999 7.87921 17.999 6.49921C17.999 5.11921 16.879 3.99921 15.499 3.99921C14.119 3.99921 12.999 5.11921 12.999 6.49921Z"
      fill={color}
    />
  </svg>
);

export default ImageLibraryIcon;
